
import { apiService } from "./api/api";
import { API_ENDPOINTS } from "../constants/api";
import {
  EquipmentCategory,
  EquipmentCategoryWithCount,
  EquipmentCategoryWithCountQuery,
  EquipmentCategoryCreate,
  EquipmentCategoryUpdate
} from '../types/equipmentCategory';

export class EquipmentCategoryService {
  async getAllCategories(): Promise<EquipmentCategory[]> {
    return await apiService.get<EquipmentCategory[]>(API_ENDPOINTS.EQUIPMENT_CATEGORY.ALL);
  }
  
  async getCategoryById(id: string): Promise<EquipmentCategory | null> {
    try {
      const endpoint = API_ENDPOINTS.EQUIPMENT_CATEGORY.GET.replace(':id', id);
      const response = await apiService.get<EquipmentCategory>(endpoint);
      return response;
    } catch (error) {
      console.error(`Error fetching category with ID ${id}:`, error);
      return null;
    }
  }


  async createCategory(data: EquipmentCategoryCreate): Promise<EquipmentCategory> {
    return await apiService.post<EquipmentCategory>(API_ENDPOINTS.EQUIPMENT_CATEGORY.CREATE, data);
  }

  async getAllCategoriesWithCount(
    params?: EquipmentCategoryWithCountQuery
  ): Promise<EquipmentCategoryWithCount[]> {
    const endpoint = API_ENDPOINTS.EQUIPMENT_CATEGORY.ALL_WITH_COUNT;
    return await apiService.get<EquipmentCategoryWithCount[]>(endpoint, { params });
  }

  async updateCategory(id: string, data: EquipmentCategoryUpdate): Promise<EquipmentCategory> {
    const endpoint = API_ENDPOINTS.EQUIPMENT_CATEGORY.UPDATE.replace(':id', id);
    return await apiService.put<EquipmentCategory>(endpoint, data);
  }

  async deleteCategory(id: string): Promise<void> {
    const endpoint = API_ENDPOINTS.EQUIPMENT_CATEGORY.DELETE.replace(':id', id);
    await apiService.delete(endpoint);
  }
}

export const equipmentCategoryService = new EquipmentCategoryService();
